<template>
	<div>
		<FooterBar
			hide-legal-notice-link
			hide-a11y-link
			hide-sitemap-link
			hide-cookies-link
			:version="versionLabel"
			:cgu-route="cguRoute"
		>
			<template #append>
				<a
					class="my-3 mx-4"
					@click="popUpAide = true"
				>
					{{ $t('components.layout.appFooter.aide') }}
				</a>
			</template>
		</FooterBar>
		<DialogBox
			v-model="popUpAide"
			:width="responsivePopUpWidth"
		>
			<template #title>
				<h3 style="word-break: keep-all">
					Assistance téléphonique
				</h3>
			</template>
			<span v-if="getUserType">
				<span v-if="getUserType === 'employeur'">
					<div class="my-3">
						{{ $t('components.layout.appFooter.textConnecte') }}
						<span class="font-weight-bold">{{ $t('components.layout.appFooter.numeroEmployeur') }}</span>
					</div>
				</span>

				<span v-else>
					<div class="my-3">
						{{ $t('components.layout.appFooter.textConnecte') }}
						<span class="font-weight-bold">{{ $t('components.layout.appFooter.numeroAssure') }}</span>
					</div>
				</span>
			</span>
			<span v-else>
				<div class="my-3">
					{{ $t('components.layout.appFooter.textNonConnecte') }}
				</div>
				<div class="my-3">
					{{ $t('components.layout.appFooter.employeur') }}
					<span class="font-weight-bold">{{ $t('components.layout.appFooter.numeroEmployeur') }}</span>
				</div>
				<div class="my-3">
					{{ $t('components.layout.appFooter.assure') }}
					<span class="font-weight-bold">{{ $t('components.layout.appFooter.numeroAssure') }}</span>
				</div>
			</span>
			<template #actions>
				<VBtn
					color="primary"
					@click="popUpAide = false"
				>
					{{ $t('components.layout.appFooter.annuler') }}
				</VBtn>
			</template>
		</DialogBox>
	</div>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';
	import { mapGetters } from 'vuex';
	import { RawLocation } from 'vue-router';

	@Component({
		computed: mapGetters('auth', ['getUserType'])
	})
	export default class AppFooter extends Vue {
		version = process.env.VUE_APP_VERSION;
		versionDate = process.env.VUE_APP_VERSION_DATE;
		popUpAide = false;

		get responsivePopUpWidth(): string {
			return this.$vuetify.breakpoint.smAndDown ? '80%' : '50%';
		}

		get versionLabel(): string {
			return this.version + ' de ' + this.versionDate.split('-').join(' ');
		}

		get cguRoute(): RawLocation {
			return { name: 'cgu' };
		}
	}
</script>

<style lang="scss" scoped>
	.v-footer > a {
		color: inherit;
		transition: 0.15s;
		text-decoration: none;
		padding-top: 1px;
		border-bottom: 1px solid transparent;

		&:hover, &:focus {
			border-color: currentColor;
		}
	}
</style>
